import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=5804c578&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"
import style0 from "./LoginLayout.vue?vue&type=style&index=0&id=5804c578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5804c578",
  null
  
)

export default component.exports